"use client";

import React from "react";
import {
  SovendusBanner,
} from "sovendus-voucher-network-and-checkout-benefits-react";

import { useSearchParams } from "next/navigation";
import { useDiscountStore } from "libs/state/src/lib/stores/useDiscountStore";
import {
  useTrackSuccessfulPurchase,
} from "apps/website/hooks/useTrackSuccessfulPurchase";

import { LoadingSpinner } from "../../form/LoadingSpinner/LoadingSpinner";

import { SovendusBannerRequiredProps } from "./types";

export const APPROVED_DISCOUNT_CODES = new Set([ "MC2-10BOX" ]);

const SovendusBannerComponent: React.FC<SovendusBannerRequiredProps> = (props) => {
  const query = useSearchParams();
  const { discountCodes } = useDiscountStore();
  const discountCode = discountCodes.find(
    (code) => code.flowId === query.get("flow"),
  )?.discountCode;
  const { firstOrder, isLoading } = useTrackSuccessfulPurchase();

  const isApprovedDiscountCode = discountCode && APPROVED_DISCOUNT_CODES.has(discountCode);

  if (isLoading) {
    return (
      <div className="w-full h-full py-4 flex items-center justify-center">
        <LoadingSpinner size={22} color="white" />
      </div>
    );
  }

  if (!firstOrder) {
    return null;
  }

  return (
    <div className="w-full h-full py-4 flex items-center justify-center">
      <SovendusBanner
        trafficSourceNumber={8107}
        trafficMediumNumber={5}
        {...(isApprovedDiscountCode && { usedCouponCode: discountCode })}
        orderId={firstOrder.chargeId.toString()}
        orderValue={Number.parseFloat(firstOrder.totalPriceDiscounted)}
        orderCurrency="GBP"
        {...props}
      />
    </div>
  );
};

export default SovendusBannerComponent;
